import { render } from "./PickingStrategySelector.vue?vue&type=template&id=08ad0839&scoped=true"
import script from "./PickingStrategySelector.vue?vue&type=script&lang=js"
export * from "./PickingStrategySelector.vue?vue&type=script&lang=js"

import "./PickingStrategySelector.vue?vue&type=style&index=0&id=08ad0839&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ad0839"]])

export default __exports__